import { create } from 'zustand'

export type ToastKind = 'error' | 'success' | 'info'

export interface Toast {
  id: number
  kind: ToastKind
  message: string
  detail?: string
}

interface ToastInput {
  kind: ToastKind
  message: string
  detail?: string
}

interface ToastStore {
  toasts: Toast[]
  pushToast: (input: ToastInput) => number
  dismissToast: (id: number) => void
  clear: () => void
}

let nextId = 1

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  pushToast: (input) => {
    const id = nextId++
    set((state) => ({ toasts: [...state.toasts, { id, ...input }] }))
    return id
  },
  dismissToast: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
  clear: () => set({ toasts: [] }),
}))
